import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TwofaSettingsComponent } from './twofa-settings.component';
import { AngularMaterialModule } from '../../angular-material/angular-material.module';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";



@NgModule({
  declarations: [TwofaSettingsComponent],
  imports: [
    CommonModule,
    AngularMaterialModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  exports: [TwofaSettingsComponent]
})
export class TwofaSettingsModule { }
